module.exports = __webpack_public_path__ + "media/fonts/bootstrap-icons-6959d0d983ee318f88804e4078c0da55.woff";